import { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import { usePage } from "@inertiajs/react"
import type { Market } from "@/lib/useMarket"
import { initialMarket } from "./lib/panelState"
import QuickViewPanel from "./QuickViewPanel"
import { closeProductQuickView, useProductQuickViewId, useProductQuickViewMarket } from "./store"

type PageProps = { market?: Market; remembered_market?: Market | null; org_markets?: Market[] }

// Mounted once by AppLayout: shows the panel for whichever product a page or
// the top bar search opened. A market picked inside the panel lasts until the
// panel closes; it never changes the remembered market or the page behind.
export default function ProductQuickViewHost() {
  const externalId = useProductQuickViewId()
  const openedMarket = useProductQuickViewMarket()
  const { props } = usePage<PageProps>()
  const [picked, setPicked] = useState<Market | null>(null)

  // Leaving the page closes the panel.
  useEffect(() => () => closeProductQuickView(), [])
  // Every opening starts again on the URL's or the remembered market.
  useEffect(() => {
    if (externalId === null) setPicked(null)
  }, [externalId])
  // A product opened from another market's section starts on that market.
  useEffect(() => {
    if (openedMarket) setPicked(null)
  }, [openedMarket])

  if (externalId === null) return null
  return createPortal(
    <QuickViewPanel
      externalId={externalId}
      market={picked ?? openedMarket ?? initialMarket(props.market, props.remembered_market)}
      markets={props.org_markets ?? []}
      onMarketChange={setPicked}
      onClose={closeProductQuickView}
    />,
    document.body,
  )
}
